import {ff} from 'mc/lib';
import {requireFields} from 'mc/lib/utils';
import React from 'react';
import {FormSection} from 'redux-form';
import SubjektForm, {connectSubjektForm} from './SubjektForm';
import {validateDatumNarozeni} from './utils';

const renderSubjektFields = ({disabled}) => (
    <div>
        <FormSection name="subjekt">
            <ff.String name="nazev" label="subjekt.form.title.nazev" required disabled={disabled}/>
            <ff.String name="ico" label="subjekt.form.title.ico" required disabled={disabled}/>
            <FormSection name="fyzickaOsoba">
                <ff.String name="titulPred" label="subjekt.form.title.titulPred" disabled={disabled}/>
                <ff.String name="jmeno" label="subjekt.form.title.jmeno" required disabled={disabled}/>
                <ff.String name="prijmeni" label="subjekt.form.title.prijmeni" required disabled={disabled}/>
                <ff.String name="titulZa" label="subjekt.form.title.titulZa" disabled={disabled}/>
                <ff.SimpleDate name="datumNarozeni" label="subjekt.form.title.datumNarozeni" required disabled={disabled}/>
            </FormSection>
            <ff.Adresa name="adresaTrv" label="subjekt.form.title.adresaTrvpobytSidlo" required disabled={disabled}/>
        </FormSection>
        <ff.Adresa name="dorucovaciAdresa" label="subjektForm.dorucovaciAdresa" disabled={disabled}/>
        <FormSection name="subjekt">
            <ff.Kontakt name="telefon" label="subjekt.form.title.kontaktVychTelefon" kontaktType="TEL" disabled={disabled}/>
        </FormSection>
    </div>

);

const SubjektFormFop = (props) => (
    <SubjektForm subjektClass="FyzickaOsobaPodVO"
                 subjektFields={renderSubjektFields}
                 verifyEnabled
                 {...props}/>
);

const validateRequiredFields = requireFields([
    'subjekt.nazev',
    'subjekt.ico',
    'subjekt.fyzickaOsoba.jmeno',
    'subjekt.fyzickaOsoba.prijmeni',
    'subjekt.fyzickaOsoba.datumNarozeni',
    'subjekt.adresaTrv',
], {trimStrings: true});

SubjektFormFop.formName = 'subjektFormFop';

SubjektFormFop.validate = values => {
    // !!! Při modifikaci, zajistěte konzistenci server-side validací SubjektValidator !!!
    const errors = {};
    validateRequiredFields(values, errors);
    validateDatumNarozeni(values, 'subjekt.fyzickaOsoba.datumNarozeni', errors);
    return errors;
};

const formConfig = {
    form: SubjektFormFop.formName,
    validate: SubjektFormFop.validate,
};

export default connectSubjektForm(SubjektFormFop, formConfig);
